import React, {Component} from 'react';
import {Helmet} from "react-helmet";
import {Button, Form, Grid, Image, Container, Card, Message} from 'semantic-ui-react';
import update from 'react-addons-update';

import auth from "../../data/auth";
import resources from "../../data/resources";
import Toast from "../../components/extras/Toast";
import localDB from "../../data/localDB";

const logo = require('../../img/logo_text1.svg');

class Register extends Component {

    constructor() {
        super();

        this.state = {
            data:{
                user:{
                    email: '',
                    password: '',
                },
                name: '',
            },
            restaurant_error: false,
            user_error: false,
            password_error: false,
            redirectToReferrer: false,
            active: false
        };

        this.handleEmailChange = this.handleEmailChange.bind(this);
        this.handlePasswordChange = this.handlePasswordChange.bind(this);
        this.handleRestaurantChange = this.handleRestaurantChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentDidMount() {
       localDB.cleanSession();
    };

    handleEmailChange(event) {
        let data = update(this.state, {
            data: {
                user: {
                    email: {
                        $set: event.target.value.toLowerCase().trim()
                    }
                }
            }
        });
        this.setState(data);

        if (event.target.value.trim() === '') {
            this.setState({user_error: true})
        } else {
            this.setState({user_error: false})
        }
    }

    handleRestaurantChange(event){
        let data = update(this.state, {
            data: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({restaurant_error: true})
        } else {
            this.setState({restaurant_error: false})
        }
    }

    handlePasswordChange(event) {
        let data = update(this.state, {
            data: {
                user: {
                    password: {
                        $set: event.target.value
                    }
                }
            }
        });
        this.setState(data);
        if (event.target.value.trim() === '') {
            this.setState({password_error: true})
        } else {
            this.setState({password_error: false})
        }
    }

    async handleSubmit(event) {
        if (this.state.data.recaptcha === null) {
            this.refs.toast.show({message: 'ReCaptcha sin valor!', type: 'error'});
        }else if (this.state.data.name === "") {
            this.setState({restaurant_error: true})
        }else if (this.state.data.user.email === "" || !resources.validators.isValidEmailAddress(this.state.data.user.email)) {
            this.setState({user_error: true})
        } else if (this.state.data.user.password === "") {
            this.setState({password_error: true})
        } else {
            this.setState({active: true});
            auth.registerStore(this.state.data, (res) => {
                this.setState({active: false});
                if(res.create){
                    this.props.history.push(`activation/${res.token}`);
                }else{
                    this.refs.toast.show({message: res.message, type: 'error'});
                }
            });
        }
        event.preventDefault();
    }

    render() {
        return (
            <div style={{minHeight: 'calc(100vh)', display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                <Toast ref='toast'/>
                <Helmet>
                    <title>Bisttros</title>
                </Helmet>
                <Grid>
                    <Grid.Row columns={2} centered>
                        <Grid.Column mobile={16} tablet={8} computer={7} largeScreen={6} widescreen={6}>
                            <Container>
                                <Image centered src={logo} alt="Bisttros Manager" size='small'/>
                                <Card fluid>
                                    <Card.Content>
                                        <Card.Header>Crear una cuenta</Card.Header>
                                    </Card.Content>
                                    <Card.Content>
                                        <Form onSubmit={this.handleSubmit}>
                                            <Form.Field>
                                                <Form.Input icon='food' iconPosition='left'
                                                            placeholder='Nombre de tu restaurante' value={this.state.restaurant}
                                                            onChange={this.handleRestaurantChange} error={this.state.restaurant_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Form.Input icon='mail' iconPosition='left'
                                                            autoComplete="username"
                                                            type='email'
                                                            placeholder='Correo Electrónico' value={this.state.data.user.email}
                                                            onChange={this.handleEmailChange} error={this.state.user_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Form.Input icon='lock' iconPosition='left' placeholder='Contraseña'
                                                            value={this.state.password} type="password"
                                                            onChange={this.handlePasswordChange}
                                                            autoComplete="current-password"
                                                            error={this.state.password_error}/>
                                            </Form.Field>
                                            <Form.Field>
                                                <Button fluid type="submit" primary disabled={this.state.active}
                                                        loading={this.state.active}>Crear Cuenta</Button>
                                            </Form.Field>
                                        </Form>
                                    </Card.Content>
                                </Card>
                                <Message>
                                    <strong>
                                        ¿Ya tienes tu cuenta?<span  className='link' onClick={()=>this.props.history.push('/login')}> Ingresa aquí</span>
                                    </strong>
                                </Message>
                            </Container>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }
}

export default Register;



// WEBPACK FOOTER //
// ./src/containers/main/Register.js